import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const Navdata = () => {

  const [isComponents, setisComponents] = useState(false);

  function updateIconSidebar(e, currentId) {
    const ul = document.getElementById("two-column-menu");
    if (ul) {
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      iconItems.forEach((item) => {
        if (item.getAttribute("subitems") !== currentId) {
          item.classList.remove("active");
          const id = item.getAttribute("subitems");
          if (document.getElementById(id)) {
            document.getElementById(id).classList.remove("show");
          }
        }
      });
    }
  }

  const menuItems = [

    {
      id: "widgets",
      label: "Dashboard",
      icon: "ri-honour-line",
      link: "/dashboard",
      pkey: "Dashboard",
      parentId: "dashboard",
    },

    {
      id: "user",
      pkey: "User",
      label: "Users",
      link: "/user",
      icon: "ri-user-line",
      parentId: "user",
    },
    {
      id: "components",
      pkey: "components",
      label: "Components",
      link: "/#",
      icon: "ri-layout-grid-fill",
      click: function (e) {
        e.preventDefault();
        setisComponents(!isComponents);
        updateIconSidebar(e);
      },
      stateVariables: isComponents,
      subItems: [
        {
          id: "name",
          pkey: "name",
          label: "Name",
          link: "/components/name",
          parentId: "components",
        },
        {
          id: "email",
          pkey: "email",
          label: "Email",
          link: "/components/email",
          parentId: "components",
        },
        {
          id: "amount",
          pkey: "amount",
          label: "Amount",
          link: "/components/amount",
          parentId: "components",
        },
        {
          id: "password",
          pkey: "password",
          label: "Password",
          link: "/components/password",
          parentId: "components",
        },
        {
          id: "string",
          pkey: "string",
          label: "String",
          link: "/components/string",
          parentId: "components",
        },
        {
          id: "phone",
          pkey: "phone",
          label: "Phone Number",
          link: "/components/phone",
          parentId: "components",
        },
        {
          id: "dropdown",
          pkey: "dropdown",
          label: "Dropdown",
          link: "/components/dropdown",
          parentId: "components",
        },
        {
          id: "multi-select-dropdown",
          pkey: "multi-select-dropdown",
          label: "Multi Select Dropdown",
          link: "/components/multi-select-dropdown",
          parentId: "components",
        },
        {
          id: "checkbox",
          pkey: "checkbox",
          label: "Single Checkbox",
          link: "/components/checkbox",
          parentId: "components",
        },
        {
          id: "multi-checkbox",
          pkey: "multi-checkbox",
          label: "Malti Checkbox",
          link: "/components/multi-checkbox",
          parentId: "components",
        },
        {
          id: "radio",
          pkey: "radio",
          label: "Radio Group",
          link: "/components/radio",
          parentId: "components",
        },
        {
          id: "file-upload",
          pkey: "file-upload",
          label: "File Upload",
          link: "/components/file-upload",
          parentId: "components",
        },
        {
          id: "date-picker",
          pkey: "date-picker",
          label: "Date Picker",
          link: "/components/date-picker",
          parentId: "components",
        },
        {
          id: "weight",
          pkey: "weight",
          label: "Weight",
          link: "/components/weight",
          parentId: "components",
        },
        {
          id: "textarea",
          pkey: "textarea",
          label: "Textarea",
          link: "/components/textarea",
          parentId: "components",
        },
        {
          id: "WYSIWYG-editor",
          pkey: "WYSIWYG-editor",
          label: "WYSIWYG Editor",
          link: "/components/WYSIWYG-editor",
          parentId: "components",
        },
        {
          id: "switch",
          pkey: "switch",
          label: "Switch",
          link: "/components/switch",
          parentId: "components",
        },
        {
          id: "range",
          pkey: "range",
          label: "Range Picker",
          link: "/components/range",
          parentId: "components",
        },
        {
          id: "dimension",
          pkey: "dimension",
          label: "Dimension",
          link: "/components/dimension",
          parentId: "components",
        },
        {
          id: "url",
          pkey: "url",
          label: "URL",
          link: "/components/url",
          parentId: "components",
        },
        {
          id: "form",
          pkey: "form",
          label: "Form",
          link: "/components/form",
          parentId: "components",
        },
        {
          id: "edit",
          pkey: "edit",
          label: "Update Form",
          link: "/components/update-form",
          parentId: "components",
        },
      ],
    },
  ];

  const dynamicmenuItems = menuItems;

  return <React.Fragment>{dynamicmenuItems}</React.Fragment>;
};
export default Navdata;
